import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { getProjects, getProjectForms } from '../../services/projectService';
import { getFormWidgets } from '../../services/formService';
import { WidgetTypes } from '../../constants/QuestionTypes';
import _ from 'lodash';
import { stripTags } from '../common/commonFuncs';
import CustomLoader from '../common/Loader';
import * as Icon from 'react-feather';
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../config';
import { logActivity } from '../../services/utilService';
import MUIDataTable from 'mui-datatables';
import ReportSettings from './ReportSettings';
import AddReport from './AddReport';

class ReportBuilder extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            projects: [],
            projectSelected: {},
            projectForms: [],
            formSelected: {},
            formsWidgetsList: [],
            reportList: [],
            selectedFormWidgetsList: [],
        };
    }

    componentDidMount() {
        this.loadProjects().
            then(() => {

                let reportList = this.state.reportList,
                    //DT Column Config
                    DTColumns = [{
                        label: 'REPORT ID',
                        align: 'center',
                        options: {
                            setCellHeaderProps: () => ({ style: { 'color': '#0061F2' } }),
                            setCellProps: () => ({ style: { 'text-align': 'left' } }),
                        }
                    },
                    {
                        label: 'REPORT NAME',
                        options: {
                            setCellHeaderProps: () => ({ style: { 'color': '#0061F2' } }),
                            setCellProps: () => ({ style: { 'text-align': 'left' } }),
                        }
                    },
                    {
                        label: 'RUN',
                        options: {
                            sort: false,
                            setCellHeaderProps: () => ({ style: { 'color': '#0061F2' } }),
                            customBodyRender: (value, tableMeta, updateValue) => {
                                return (
                                    <Icon.Play id='reportRun' className='btn-primary btn-circle pointer' size={24} onClick={() => console.log(value, tableMeta)} />
                                )
                            }
                        }
                    },
                    {
                        label: 'CONFIGURE',
                        options: {
                            sort: false,
                            setCellHeaderProps: () => ({ style: { 'color': '#0061F2' } }),
                            customBodyRender: (value, tableMeta, updateValue) => {
                                return (
                                    <Icon.PenTool id='reportConfigure' className='btn-warning btn-circle pointer' size={24} onClick={() => this.gotoReport(value, tableMeta)} />
                                )
                            }
                        }
                    },
                    {
                        label: 'DELETE',
                        options: {
                            sort: false,
                            setCellHeaderProps: () => ({ style: { 'color': '#0061F2' } }),
                            customBodyRender: (value, tableMeta, updateValue) => {
                                return (
                                    <Icon.Trash2 id='reportDelete' className='btn-danger btn-circle pointer' size={24} onClick={() => console.log(value, tableMeta)} />
                                )
                            }
                        }
                    }],

                    //DT Options Config
                    DTOptions = {
                        filter: true,
                        filterType: 'textField',
                        download: false,
                        print: false,
                        jumpToPage: true,
                        responsive: 'stacked',
                        selectableRowsHeader: false,
                        selectableRows: 'none',
                        pagination: true,
                        rowsPerPageOptions: [10, 15, 30, 50, 100],
                        textLabels: {
                            body: {
                                noMatch: 'Sorry, No available Reports!',
                            }
                        },

                    }

                //Set initial DT State
                reportList['DTOptions'] = DTOptions;
                reportList['DTColumns'] = DTColumns;
                reportList['DTData'] = [[1, 'Test Report - ScreendedSubjects']];
                this.setState({ reportList });
            }).
            then(
                () => {
                    this.setState({ loading: false });
                });
    }

    loadProjects = async () => {
        const { data: projects } = await getProjects();
        this.setState({ projects });
        //console.log('p', projects)
    };

    gotoReport = (value, tableMetaData) => {
        //console.log("goto: ", tableMetaData.rowData);
        //<ReportSettings rowdata={tableMetaData.rowdata}/>;
        this.props.history.push(`/reportSettings?report_id=${tableMetaData.rowData[0]}`, { rowData: tableMetaData.rowData });
    }

    render() {
        const { projects, reportList } = this.state;

        const loading = (<CustomLoader loading={this.state.loading} />);
        try {
            if (this.state.loading) { return loading }
            else {
                return (
                    <React.Fragment>
                        <header className='page-header page-header-dark bg-gradient-primary-to-secondary pb-10'>
                            <div className='container'>

                                <div className='page-header-content pt-4'>
                                    <div className='row align-items-center justify-content-between'>
                                        <div className='col-auto mt-4'>
                                            <h1 className='page-header-title'>
                                                <div className='page-header-icon'>
                                                    <Icon.Settings />
                                                </div>
                                                Report Configurations
                                            </h1>
                                            <div className='page-header-subtitle'>
                                                MQUARK Report Building Tool.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </header>
                        {/* Add new report */}
                        <div className='container mt-n10'>
                            <AddReport preloadData={undefined} />
                        </div>
                        {/* List of reports */}
                        <div className='card-body' id='customDT' table th>
                            <MUIDataTable
                                key={'DTOptions'}
                                title={'Available Reports'}
                                options={reportList['DTOptions']}
                                columns={reportList['DTColumns']}
                                data={reportList['DTData']}
                            />
                        </div>
                    </React.Fragment >
                );
            }
        }
        catch (e) {
            console.error('Error loading Report BUilder: ', e);
            return (loading);
        }
    }
}

export default withRouter(ReportBuilder);